import { PageLink } from '../../../../../../assets/layout/core'

export const breadcrumbCreate: PageLink[] = [
  {
    title: 'Fases de processo',
    path: '/commercial/phasesProcess',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
